import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDefectActDivision, IDefectActSignerCompany, IServiceOrg } from './interfaces';

export const getDefectActDivisionList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDefectActDivision[]>('/defectActDivision/list', data)
    .then((response) => response.data);
};

export const getDefectActDivisionAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/defectActDivision/availableColumns')
    .then((response) => response.data);
};

export const getDefectActDivisionAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/defectActDivision/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDefectActDivision = (defectActDivisionId: number) => {
  return instance()
    .get<IDefectActDivision>(`/defectActDivision/load/${defectActDivisionId}`)
    .then((response) => response.data);
};

export const createDefectActDivision = (defectActDivision: IDefectActDivision) => {
  return instance()
    .post<IDefectActDivision>(`/defectActDivision/save`, defectActDivision)
    .then((response) => response.data);
};

export const updateDefectActDivision = (defectActDivision: IDefectActDivision) => {
  return instance()
    .post<IDefectActDivision>(`/defectActDivision/${defectActDivision.defectActDivisionId}/update`, defectActDivision)
    .then((response) => response.data);
};

// dictinaries
export const getServiceOrgs = () => {
  return instance()
    .post<IServiceOrg[]>('/dictionary/serviceOrgsParams', {})
    .then((response) => response.data);
};

export const getDefectActSignerCompanies = () => {
  return instance()
    .post<IDefectActSignerCompany[]>('/defectAct/listSignerCompanies', {})
    .then((response) => response.data);
};
